import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  EnrichBatchPayload,
  EnrichBatchResult
} from "../../recommendation.types";

export const requestEnrichBatch = async (
  payload: EnrichBatchPayload
): Promise<EnrichBatchResult> => {
  return await instance.post(ApiRoutesRecommendation.EnrichmentBatch, payload);
};
